import api from "../api/axios";
import fetcher from "../api/fetacher";

export const listUsers = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/user/list", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const gatAllUser = async ({ program, nameOrEmail }) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const params = {
      programId: program,
    };
    if (nameOrEmail) {
      params.nameOrEmail = nameOrEmail;
    }
    const res = await fetcher(
      "/user",
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
      params,
      true,
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/user", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const getOneUser = async (id) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher(`/user/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const updateUser = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/user/update", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const changeUserPassword = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/user/password/update", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const resetUserPassword = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const res = await fetcher("/user/password/reset", {
      method: "POST",
      body: JSON.stringify(data),
      // headers: {
      //   Authorization: `Bearer ${accessToken}`,
      // },
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const downloadUser = async ({ program, nameOrEmail }) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const params = {
      programId: program,
    };
    if (nameOrEmail) {
      params.nameOrEmail = nameOrEmail;
    }
    const res = await fetcher(
      "/user/download",
      {
        method: "GET",
        // responseType: "blob",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
      params,
      true,
    );

    return res;
  } catch (error) {
    throw error;
  }
};
